import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import LatestMovies from '@/pages/home/components/LatestMovies';
import HotSeries from '@/pages/home/components/HotSeries';
import CategoryExplorer from '@/pages/home/components/CategoryExplorer';
import RankingList from '@/pages/home/components/RankingList';
import WatchGuide from '@/pages/home/components/WatchGuide';
import UpdateCalendar from '@/pages/home/components/UpdateCalendar';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSite from '@/pages/home/components/AboutSite';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <LatestMovies />
        <HotSeries />
        <CategoryExplorer />
        <RankingList />
        <WatchGuide />
        <UpdateCalendar />
        <FaqSection />
        <AboutSite />
      </main>
      <SiteFooter />
    </div>
  );
}